

























import Vue from "vue";

export default Vue.extend({
  name: "Loading",
  props: {
    size: String,
  },
  data() {
    return {};
  },
  methods: {},
});
